document.addEventListener('DOMContentLoaded', () => {
    let retryCount = 0;
    const maxRetries = 10;

    function waitForEmbla(callback) {
        if (typeof EmblaCarousel === 'undefined') {
            if (retryCount >= maxRetries) {
                console.warn('[ProductFeatures] Embla carousel library not found after retries');
                return;
            }
            retryCount++;
            setTimeout(() => waitForEmbla(callback), 100);
            return;
        }
        retryCount = 0;
        callback();
    }

    function initProductFeatures() {
        const mediaRoot = document.querySelector('.embla-media');
        const contentRoot = document.querySelector('.embla-content');

        if (!mediaRoot || !contentRoot) {
            return;
        }

        const mediaViewport = mediaRoot.querySelector('.embla__viewport');
        const contentViewport = contentRoot.querySelector('.embla__viewport');

        if (!mediaViewport || !contentViewport) {
            console.error('[ProductFeatures] Viewport elements not found');
            return;
        }

        try {
            const emblaOptions = {
                loop: false,
                dragFree: false,
                containScroll: 'trimSnaps'
            };

            const mediaEmbla = EmblaCarousel(mediaViewport, emblaOptions);
            const contentEmbla = EmblaCarousel(contentViewport, emblaOptions);

            let isSyncing = false;

            mediaEmbla.on('select', () => {
                if (isSyncing) return;
                isSyncing = true;
                const index = mediaEmbla.selectedScrollSnap();
                if (contentEmbla.selectedScrollSnap() !== index) {
                    contentEmbla.scrollTo(index);
                }
                isSyncing = false;
            });

            contentEmbla.on('select', () => {
                if (isSyncing) return;
                isSyncing = true;
                const index = contentEmbla.selectedScrollSnap();
                if (mediaEmbla.selectedScrollSnap() !== index) {
                    mediaEmbla.scrollTo(index);
                }
                isSyncing = false;
            });

            const prevButton = contentRoot.querySelector('.embla__prev');
            const nextButton = contentRoot.querySelector('.embla__next');

            if (prevButton) {
                prevButton.setAttribute('aria-label', 'Previous slide');
                prevButton.addEventListener('click', () => {
                    contentEmbla.scrollPrev();
                });
            }

            if (nextButton) {
                nextButton.setAttribute('aria-label', 'Next slide');
                nextButton.addEventListener('click', () => {
                    contentEmbla.scrollNext();
                });
            }

            const updateButtons = () => {
                if (prevButton) {
                    prevButton.disabled = !contentEmbla.canScrollPrev();
                }
                if (nextButton) {
                    nextButton.disabled = !contentEmbla.canScrollNext();
                }
            };

            contentEmbla.on('select', updateButtons);
            mediaEmbla.on('select', updateButtons);
            updateButtons();

            const dots = contentRoot.querySelectorAll('.embla__dot');

            if (dots.length > 0) {
                dots.forEach((dot, index) => {
                    dot.addEventListener('click', () => {
                        mediaEmbla.scrollTo(index);
                        contentEmbla.scrollTo(index);
                    });

                    dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
                    dot.setAttribute('role', 'button');
                    dot.setAttribute('tabindex', '0');
                });

                const updateDots = () => {
                    const selectedIndex = contentEmbla.selectedScrollSnap();
                    dots.forEach((dot, index) => {
                        const isActive = index === selectedIndex;
                        dot.classList.toggle('bg-black', isActive);
                        dot.classList.toggle('bg-[#7E7E7E40]', !isActive);
                        dot.setAttribute('aria-current', isActive ? 'page' : 'false');
                    });
                };

                contentEmbla.on('select', updateDots);
                mediaEmbla.on('select', updateDots);
                updateDots();
            }
        } catch (error) {
            console.error('[ProductFeatures] Error initializing carousel:', error);
        }
    }

    waitForEmbla(() => {
        initProductFeatures();
    });
});
